import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import SettingsForm from "./SettingForm";
const Settings = () => {
  return (
    <div>
      <div className="classroom-cnt">
        <div className="classroom-container">
          <img src={classRoomImg} className="img" alt="Classroom" />
          <h2 className="text">Account Settings</h2>
        </div>

        <div>
          <SettingsForm />
        </div>
      </div>
    </div>
  );
};

export default Settings;
